<div class="main">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate" [diameter]=40>
  </mat-progress-spinner>
</div>
